import { useNavigate, generatePath } from 'react-router-dom'
import { COLLECTIONS, PATHS } from '__constants__'
import { useTranslations, useEvent } from 'hooks'
import { deleteDocument } from 'services/api/firebase'
import { message } from 'antd'
import { useMemo } from 'react'

/* Path's */
const createPath =
  PATHS.AUTHENTICATED.ORDER_CREATE || PATHS.AUTHENTICATED.ORDER_WIZARD
const editPath = PATHS.AUTHENTICATED.ORDER_EDIT
const showPath = PATHS.AUTHENTICATED.ORDER_SHOW

const useOrderBaseActions = ({ orderId, actions } = {}) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting navigate instance */
  const navigate = useNavigate()

  /* Function to handle back click */
  const handleBack = useEvent(() => navigate(-1))

  /* Handling opening of the create page */
  const handleCreate = useEvent(() => {
    navigate(createPath)
  })

  /* Handling opening of the show page */
  const handleOpen = useEvent(() => {
    const pathParams = { orderId }
    const path = generatePath(showPath, pathParams)
    navigate(path)
  })

  /* Handling opening of the edit page or change view to edit mode */
  const handleEdit = useEvent(() => {
    const pathParams = { orderId }
    const path = generatePath(editPath, pathParams)
    navigate(path)
  })

  const handleDelete = useEvent(async () => {
    try {
      await deleteDocument(COLLECTIONS.ORDERS, orderId)
      message.success(t('Order successfully deleted'))
    } catch (error) {
      message.error(error.message)
    }
  })

  return useMemo(
    () => ({
      onBack: handleBack,
      onCreate: handleCreate,
      onOpen: handleOpen,
      onEdit: handleEdit,
      onDelete: handleDelete,
      ...(actions || {}),
      createPath,
      editPath,
      showPath
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      actions?.onBack,
      actions?.onCreate,
      actions?.onDelete,
      actions?.onEdit,
      actions?.onOpen,
      handleBack,
      handleCreate,
      handleDelete,
      handleEdit,
      handleOpen
    ]
  )
}

export default useOrderBaseActions
